exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  --primary: #013188;\n  --primary-darker: #002d72;\n  --secondary: #ff720a;\n  --secondary-darker: #dd5f13;\n  --button-text: #fefefe;\n  --disabled: #c2c2c2;\n  --button-text-disabled: rgba(0,0,0,0.38);\n  --bg-auth: url(" + require("assets/imgs/login/bg.jpg") + ");\n  --logo-auth: none;\n  --logo-header: none;\n  --favicon: none;\n}\n[data-component='customer-service'] .title {\n  color: #ff720a;\n  color: var(--secondary);\n  margin: 0 0 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/customer-service/customer-service.component.styl
// module id = ../../../../../src/app/master/customer-service/customer-service.component.styl
// module chunks = main